import {TransactionBoarderResponse} from "@/types/service-response";

export default class TransactionBoarder {
  private constructor(
    readonly id: number,
    readonly customer: {
      id: number
      name: string
    },
    readonly status: {
      name: string
    },
    readonly person: {
      familyName: string
      firstName: string
      id: number
      wallets: [
        {
          currency: string
          currentBalance: number
          id: number
        }
      ]
    },
    readonly bankIdentificationCode: number,
    readonly boarderGroupCollection: [
      {
        id: number
        name: string
      }
    ]
  ) {}


  static createFromResponse(responseData: TransactionBoarderResponse): TransactionBoarder {
    return new TransactionBoarder(
      responseData.id,
      responseData.customer,
      responseData.status,
      responseData.person,
      responseData.bankIdentificationCode,
      responseData.boarderGroupCollection
    )
  }
}